/*
 * Copyright (c) 2025 Autire Technologies, LLC. All Rights Reserved.
 *
 * This product and related documentation is protected by copyright and
 * distributed under licenses restricting its use, copying, distribution and
 * decompilation. No part of this product or related documentation may be
 * reproduced in any form by any means without prior written authorization
 * from Autire Technologies, LLC and/or its licensors.
 */
import { decrypt, encrypt } from '../constants';
import { projectService } from '../services';
import { isDevUser } from '../helpers/utility';

export const projectActions = {
  getRole,
  getMultiRole,
  getAnnouncements,
  getSoftwareReleases,
  gitBranchRefresher,
  getCreatePlanPermission,
  getUserCpaList,
};

function getUserCpaList(data, callback) {
  return () => {
    projectService
      .getUserCpaList(data)
      .then((response) => {
        let res = JSON.parse(decrypt(response.r));
        let list = res.data;
        let cpaList = list;
        if (data.cpaId == 'ALL') {
          let containsDevOpsEmail = isDevUser();
          cpaList = cpaList.filter((cpa) => cpa.cpaId != 'ALL');
          cpaList = cpaList.filter(
            (cpa) =>
              ((cpa.cpaId == 'DevOps' || cpa.cpaId == 'DEVOPSTEST') && containsDevOpsEmail) ||
              (cpa.cpaId != 'DevOps' && cpa.cpaId != 'DEVOPSTEST')
          );
        }
        callback(null, cpaList);
      })
      .catch(function () {});
  };
}

function getRole(params, callback) {
  return () => {
    let param = encrypt(params);
    projectService
      .getRole(params)
      .then((response) => {
        let res = JSON.parse(decrypt(response.r));
        callback(null, res);
      })
      .catch(function () {});
  };
}

function getCreatePlanPermission(params, callback) {
  return () => {
    projectService
      .getCreatePlanPermission(params)
      .then((response) => {
        callback(null, response);
      })
      .catch(function () {});
  };
}

function getMultiRole(params, callback) {
  return () => {
    let param = encrypt(params);
    projectService
      .getMultiRole(params)
      .then((response) => {
        let res = JSON.parse(decrypt(response.r));
        callback(null, res);
      })
      .catch(function () {});
  };
}

function getAnnouncements(params, callback) {
  return () => {
    projectService
      .getAnnouncements(params)
      .then((response) => {
        callback(null, response);
      })
      .catch(function (error) {
        callback(error, null);
      });
  };
}

function gitBranchRefresher(params, callback) {
  return () => {
    projectService
      .gitBranchRefresher(params)
      .then((response) => {
        callback(null, response);
      })
      .catch(function () {});
  };
}

function getSoftwareReleases(params, callback) {
  return () => {
    projectService
      .getSoftwareReleases(params)
      .then((response) => {
        callback(null, response);
      })
      .catch(function () {});
  };
}
